import React from 'react';
import { AsSelect } from '@adserve/adserve-react-components';
import { labelStyle, inputStyle } from '../../styles';

const AsSelectWithPlaceholder = ({
    disabled = false,
    disabledStyle,
    labelStyleOverride,
    selectStyleOverride,
    placeholderText = 'Select...',
    placeholderId = '-1',
    value,
    values,
    onChange,
    required = false,
    ...props
}) => {
    const placeholderValue = { id: placeholderId, name: placeholderText };

    if (!values) values = [placeholderValue];

    if (!required && values?.length > 0 && values?.filter((e) => e.name === placeholderValue.name).length === 0) {
        values.unshift(placeholderValue);
    }

    const handleChange = (e) => {
        if (typeof onChange !== 'function') return;

        // Select converts the type '==' is required
        if (e.target.value === placeholderValue.id && placeholderValue.id !== window.emptyGuid) {
            e.target.value = undefined;
        }
        onChange(e);
    };

    return (
        <AsSelect
            {...props}
            placeholder={required ? undefined : placeholderText}
            labelStyle={{ ...labelStyle, ...labelStyleOverride }}
            selectStyle={{ ...inputStyle, ...selectStyleOverride }}
            disabledStyle={disabledStyle}
            disabled={disabled}
            onChange={handleChange}
            value={value}
            values={values}
            disableTooltip={true}
        />
    );
};

export default AsSelectWithPlaceholder;
